import blocks from '@/configurations/templates/blocks'
import Configuration from '@/classes/templates/Configuration'
import { guid } from '@/utils/utils'
import { get as _get, mapValues as _mapValues } from 'lodash'

export default class Block {
  constructor ({ name = null, attributes = {}, configuration } = {}) {
    this.id = name + guid(2)
    this.name = name
    this.attributes = attributes
    this.configuration = configuration ? new Configuration(configuration) : null
  }

  get reference () {
    return blocks.find(({ name }) => name === this.name)
  }

  get component_path () {
    return this.reference?.component_path
  }

  get settings () {
    return this.reference?.settings || {}
  }

  isShowed (model) {
    return _get(this.attributes, `show_${model}`, false)
  }

  getText (name) {
    name = name ? `text_${name}`: 'text'

    if (`${name}_singular` in this.attributes && `${name}_plural` in this.attributes)
      return _mapValues(this.attributes[`${name}_singular`], (value, key) => [value, this.attributes[`${name}_plural`][key]].join(' | '))

    return _get(this.attributes, name)
  }
}